import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { User, UsersStore } from '@fry/lib/users';
import { ProfileStore } from '@fry/lib/profile';
import { switchMap } from 'rxjs/operators';


@Injectable()
export class UserEditResolver  {

    constructor(private users: UsersStore, private profile: ProfileStore) { }

    resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<User> {
        const id = route.paramMap.get('user');
        if (id === 'profile') {
            // Always fetch fresh data from API when trying to edit
            return this.profile.getCurrent().pipe(
                switchMap(profile => this.users.getByUsername(profile.doc.user))
            );
        }

        return this.users.getByUsername(id);
    }
}
